/**
 * Processes cell metrics data from the backend.
 * Converts keys to camelCase and optionally processes units.
 * @param {Array} data - Array of cell metric objects from backend.
 * @returns {Array} Processed cell metrics.
 */
export const processCellMetricsData = (data) => {
  if (!data || !Array.isArray(data)) {
    console.warn('Invalid data received:', data);
    return [];
  }

  try {
    const processed = data.map(row => ({
      timestamp: parseInt(row.ts_ms),
      cellMilliVolt: parseInt(row.cell_mv)/1000, // Convert to volts
      cellTempC: parseInt(row.cell_temp_c),
      cellStatus: parseInt(row.cell_status),
      slaveId: parseInt(row.sid), // Ensure numeric
      cellIndex: parseInt(row.cell_index) // Ensure numeric
    }))
    // Sort by timestamp, slaveId, and cellIndex for consistent display
    .sort((a, b) => 
      a.timestamp - b.timestamp || 
      a.slaveId - b.slaveId || 
      a.cellIndex - b.cellIndex
    );

    console.log('Processed cell data:', {
      total: processed.length,
      uniqueSlaves: [...new Set(processed.map(p => p.slaveId))].sort((a, b) => a - b),
      uniqueCells: [...new Set(processed.map(p => p.cellIndex))].sort((a, b) => a - b)
    });

    return processed;
  } catch (error) {
    console.error('Error processing data:', error);
    return [];
  }
};

export default {
  processCellMetricsData
};